import { Pipe, PipeTransform } from '@angular/core';

declare let moment: any;

@Pipe({
  name: 'isoDateToExpirationFormat'
})
export class IsoDateToExpirationFormatPipe implements PipeTransform {
  transform(value: string, format: string = 'MM/YY'): string {
    if (value) {
      return moment(value).format(format);
    }

    return 'n/a';
  }
}



// WEBPACK FOOTER //
// /app/src/app/pipes/iso-date-to-expiration-format.pipe.ts